// DEFINE SOME TYPES
/**
 * @typedef {object} ProductDict
 * @property {string} slug
 * @property {string} name
 * @property {float} price
 * @property {[SKUDict]} skus
 */

/**
 * @typedef {object} SKUDict
 * @property {string} name
 * @property {string} description
 */


/**
 * @typedef {object} OrderSubmitResponse
 * @property {string} redirect
 * @property {string} payment_error
 * @property {string} order_update_url
 * @property {string} order_review_html
 * @property {string} is_error
 * @property {string} error_html
 */


// IMPORT SOME UTILITY FUNCTIONS
global._ = {
    pickBy: require('lodash.pickby'),
    filter: require('lodash.filter'),
    values: require('lodash.values'),
    map: require('lodash.map'),
    reduce: require('lodash.reduce'),
    flatten: require('lodash.flatten'),
    isUndefined: require('lodash.isundefined'),
    countBy: require('lodash.countby')
};
var array_fill = require('locutus/php/array/array_fill');
var array_values = require('locutus/php/array/array_values');
var array_keys = require('locutus/php/array/array_keys');
var nl2br = require('locutus/php/strings/nl2br');

/**
 * @param {object}  order_form_selector
 * @param {object} products_dictionary
 * @param {ProductDict}  products_dictionary.regular_membership
 * @param {ProductDict}  products_dictionary.super_membership
 * @param {ProductDict}  products_dictionary.medallion_membership
 * @param {ProductDict}  products_dictionary.regular_shirt
 * @param {ProductDict}  products_dictionary.regular_shirt_addon
 * @param {ProductDict}  products_dictionary.super_shirt
 * @param {ProductDict}  products_dictionary.medallion_hoodie
 * @param {ProductDict}  products_dictionary.blue_canary_light
 * @param {ProductDict}  products_dictionary.mug
 * @param {ProductDict}  products_dictionary.new_album_cd
 * @param {ProductDict}  products_dictionary.new_album_vinyl
 * @param {ProductDict}  products_dictionary.beast_cd
 * @param {ProductDict}  products_dictionary.beast_vinyl
 * @param {ProductDict}  products_dictionary.first_album_art_puzzle
 * @param {ProductDict}  products_dictionary.intl_shipping
 * @param {ProductDict}  products_dictionary.addon_shipping
 * @param {string}  fetch_client_token_url
 * @param {string}  ajax_order_create_url
 * @param {string}  paypal_env
 * @param {string}  customer_support_email
 * @param {object}  hosted_fields_styles_object
 * @param {object}  hosted_fields_styles_object
 * @param {string}  hosted_fields_number_selector
 * @param {string}  hosted_fields_cvv_selector
 * @param {string}  hosted_fields_exp_selector
 * @param {string}  hosted_fields_post_code_selector
 * @param {string}  paypal_button_selector
 * @param {object}  paypal_button_styles_object
 * @param {string}  pppin4_selector

  */
function OrderViewModel(order_form_selector,
                        products_dictionary,
                        customer_support_email,
                        fetch_client_token_url,
                        ajax_order_create_url,
                        paypal_env,
                        hosted_fields_styles_object,
                        hosted_fields_number_selector,
                        hosted_fields_cvv_selector,
                        hosted_fields_exp_selector,
                        hosted_fields_post_code_selector,
                        paypal_button_selector,
                        paypal_button_styles_object,
                        pppin4_selector) {
    // helper variables (before view model definitions)
    var product_skus_to_price = _.reduce(products_dictionary, function (carry, product_dict) {
        /** @param {ProductDict} product_dict  */
        product_dict.skus.forEach(function (sku_dict) {
            carry[sku_dict.skuid] = product_dict.price;
        });
        return carry;
    }, {});


    var self = this;

    self.order_type = ko.observable().extend({required: true});

    /** @returns {ProductDict} */
    self.membership_product = ko.pureComputed(function () {
        return products_dictionary[self.order_type()];
    });

    // MEMBERSHIP SHIRTS
    self.regular_shirt = ko.observable().extend({required: true});

    // remember that these products must also be added to the dict submitted to the server...
    self.super_shirt_required = ko.pureComputed(function () {
        return self.membership_product() === products_dictionary.super_membership ||
            self.membership_product() == products_dictionary.medallion_membership;
    });
    self.super_shirt = ko.observable().extend({required: self.super_shirt_required});

    self.medallion_hoodie_required = ko.pureComputed(function () {
        return self.membership_product() == products_dictionary.medallion_membership;
    });
    self.medallion_hoodie = ko.observable().extend({required: self.medallion_hoodie_required});

    self.is_gift = ko.observable();
    self.include_gift_message = ko.observable(false);
    self.gift_message = ko.observable().extend({maxLength: 900});
    self.is_gift.subscribe(function (value) {
        // don't submit anything if there is no gift
        if (value === false) {
            self.include_gift_message(false);
            self.gift_message('');
        }
    });
    self.name_pronunciation = ko.observable().extend({maxLength: 900, required:self.medallion_hoodie_required});
    self.name_pronunciation_url = ko.observable();
    self.medallion_hoodie_required.subscribe(function (value) {
        if (value === false) {
            self.name_pronunciation('');
            self.name_pronunciation_url('');
        }
    });

    // EXTRA PRODUCTS with VIRTUAL TOGGLES
    // Virtual toggles are boolean writable computeds
    // which read based on another property, and alter that property on write
    self.extra_ifc_shirts = ko.observableArray().extend({array_members_valid: true});
    self.add_shirt = function () {
        self.extra_ifc_shirts.push(ko.observable().extend({required: true}));
    };
    self.n_extra_ifc_shirts = ko.computed(function () {
        return self.extra_ifc_shirts().length;
    });

    self.extra_ifc_shirts_toggle = ko.computed({
        read: function () {
            return self.n_extra_ifc_shirts() > 0;
        },
        write: function (value) {
            if (value === true) self.add_shirt();
            else self.extra_ifc_shirts.removeAll();
        }
    });

    self.n_new_album_cd = ko.observable(0);
    self.n_new_album_vinyl = ko.observable(0);
    self.n_blue_canary_light = ko.observable(0);
    self.n_beast_cd = ko.observable(0);
    self.n_beast_vinyl = ko.observable(0);
    self.n_mug = ko.observable(0);
    self.n_first_album_art_puzzle = ko.observable(0);

    self.has_addons = ko.pureComputed(function() {
        return self.extra_ifc_shirts_toggle() ||
                self.n_new_album_cd() > 0 ||
                self.n_new_album_vinyl() > 0 ||
                self.n_blue_canary_light() > 0 ||
                self.n_beast_cd() > 0 ||
                self.n_beast_vinyl() > 0 ||
                self.n_mug() > 0 ||
                self.n_first_album_art_puzzle() > 0
    });

    // SUB MODELS
    self.purchaser = new CustomerViewModel(true, ko.pureComputed(function () {
        return !self.is_gift();
    }));
    self.recipient = new CustomerViewModel(self.is_gift, self.is_gift);

    self.destination_is_intl = ko.pureComputed(function () {
        return self.is_gift() ? self.recipient.is_intl() : self.purchaser.is_intl();
    });

    self.selected_skus_js = ko.pureComputed(function () {
        skuToCount = _.reduce({
            // ALL THE SINGLE SKU PRODUCTS WE ACCOUNT FOR WITH BASIC COUNT OBSERVABLES
            'new_album_cd': self.n_new_album_cd,
            'new_album_vinyl': self.n_new_album_vinyl,
            'blue_canary_light' : self.n_blue_canary_light,
            'beast_cd' : self.n_beast_cd,
            'beast_vinyl' : self.n_beast_vinyl,
            'mug' : self.n_mug,
            'first_album_art_puzzle' : self.n_first_album_art_puzzle
        }, function (accumulator, value, key, collection) {
            var qty = parseInt(value());
            if (qty > 0) {
                // don't add nothins into the dict...
                accumulator[products_dictionary[key].skus[0].skuid] = qty;
            }
            return accumulator;
        }, _.countBy(_.filter(
            // start with the accumulator set to a count of the occurrence of the multi sku prods
            // dump the extra ifc shirts into a js array as it's an obserable array with obs members...
            [self.regular_shirt(), self.super_shirt(),self.medallion_hoodie()].concat(ko.toJS(self.extra_ifc_shirts)))));

        // add in the sku for the membership product!
        if (self.membership_product()) {
            // but only if it's not undefined (it starts as undefined)
            skuToCount[self.membership_product().skus[0].skuid] = 1;
        }

        if (self.destination_is_intl()) {
            skuToCount[products_dictionary.intl_shipping.skus[0].skuid] = 1;
        }

        if (self.has_addons()) {
            skuToCount[products_dictionary.addon_shipping.skus[0].skuid] = 1;
        }

        return skuToCount;
    });
    // IMPLEMENTATION FIELDS
    self.selected_skus = ko.pureComputed({
        read: function () {
            // get all the non null properties from this list
            return ko.toJSON(self.selected_skus_js());
        },
        write: function () {
        }
    });

    self.total_price = ko.pureComputed(function () {
        return _.reduce(self.selected_skus_js(), function (carry, qty, skuid) {
            return carry + product_skus_to_price[skuid] * qty;
        }, 0);
    });


    self.order_update_url = ko.observable();
    self.ajax_url = ko.pureComputed(function () {
        return self.order_update_url() ? self.order_update_url() : ajax_order_create_url;
    });

    // CLIENT SIDE VALIDATION
    // anything that has this property can be validated
    // we want all of them... and i can't get them all together
    // naturally??
    validateable_dict = function (obj, prefix) {
        return _.reduce(_.filter(Object.keys(obj), function (propname) {
            return !!obj[propname].isValid;
        }), function (carry, el) {
            carry[prefix ? prefix + el : el] = obj[el];
            return carry;
        }, {});
    };
    self.validateable_properties = validateable_dict(self);
    $.extend(self.validateable_properties, validateable_dict(self.purchaser, 'purchaser.'), validateable_dict(self.recipient, 'recipient.'));


    self.invalid_properties = ko.pureComputed(function () {
        return array_keys(_.pickBy(self.validateable_properties, function (prop, key) {
            if (!prop.isValid()) return key;
        }));
    });
    self.n_invalid_properties = ko.pureComputed(function () {
        return self.invalid_properties().length;
    });
    self.order_form_valid = ko.pureComputed(function () {
        return self.n_invalid_properties() === 0;
    });


    self.validateable_property_nice_name = function (mean_name) {
        var nice_names = {
            'extra_ifc_shirts': 'IFC Add-on Shirts',
            'gift_message': 'Message to gift recipient',
            'name_pronunciation': 'Phonetic name spelling',
            'purchaser.city': 'Purchaser City',
            'purchaser.confirm_email': 'Purchaser Email Confirmation',
            'purchaser.country': 'Purchaser Country',
            'purchaser.email': 'Purchaser Email',
            'purchaser.first_name': 'Purchaser First Name',
            'purchaser.last_name': 'Purchaser Last Name',
            'purchaser.phone': 'Purchaser Phone',
            'purchaser.postal_code': 'Purchaser Postal Code',
            'purchaser.state_province': 'Purchaser State/Province',
            'purchaser.street1': 'Purchaser Street Address',
            'recipient.city': 'Gift Recipient City',
            'recipient.confirm_email': 'Gift Recipient Email Confirmation',
            'recipient.country': 'Gift Recipient Country',
            'recipient.email': 'Gift Recipient Email',
            'recipient.first_name': 'Gift Recipient First Name',
            'recipient.last_name': 'Gift Recipient Last Name',
            'recipient.phone': 'Gift Recipient Phone',
            'recipient.postal_code': 'Gift Recipient Postal Code',
            'recipient.state_province': 'Gift Recipient State/Province',
            'recipient.street1': 'Gift Recipient Street Address',
            'regular_shirt': 'IFC Premiere Level Shirt',
            'super_shirt': 'Executive Super-Boss Shirt',
            'medallion_hoodie': 'Medallion Level Zip Hoodie'
        };

        if (nice_names.hasOwnProperty(mean_name)) {
            return nice_names[mean_name];
        }

        return mean_name;
    };

    // FORM SUBMISSION AND UPDATES
    var ifc_ajax_retry = require('./ifc-ajax-retry');

    // this will change when the form changes
    // by ensnaring ko.toJson in our closure we get updates on teh whole
    // hierarchy
    // then we reach out of ko for the old school form submission data
    // we throttle notifications as this data can be very volatile
    // we cannot make it part of the view model or it will be serialized itself
    // and it will be very circular and bad
    var serialized_form_data = ko.computed(function () {
        if (ko.toJSON(self)) return $(order_form_selector).serialize();
    }).extend({rateLimit: {method: "notifyWhenChangesStop", timeout: 1000}, deferred: true});

    // track whatever we sent in before
    self.previous_submission = '';
    // can we even do a submit? by making this an observable this will trigger
    // a form change and a resubmit if we were locked out of a previously valid submission
    self.submission_lockout = ko.observable(false);
    serialized_form_data.subscribe(function (current_submission) {
        // we only submit valid order forms
        // while not locked out
        // that differ from what we previously submitted
        console.log("subscribed update");
        console.log(current_submission);
        console.log("valid: " + self.order_form_valid());
        if (self.order_form_valid() &&
            !self.submission_lockout() &&
            current_submission !== self.previous_submission) {
            // we lockout if we are gonna start
            self.submission_lockout(true);
            // if we have something new to say, say it
            ifc_ajax_retry('POST', 'json', self.ajax_url, 5,
                serialized_form_data,
                recoverable_payment_error_callback,
                function () {
                    // it submitted something that wasn't valid just now... 
                    if (self.order_form_valid()) {
                        $(order_form_selector).submit();
                    }
                },
                /** @param {OrderSubmitResponse} response  */
                function (response) {
                    if (response.redirect) {
                        window.location.href = response.redirect;
                        return;
                    }

                    if (response.payment_error) {
                        self.unblock_ui();
                        self.submission_lockout(false);
                        var generic_alt = 'There was an error processing your payment method. ' +
                            'Please check your payment method details and try again.';

                        self.payment_error_message(generic_alt);
                        alert(generic_alt);
                        return;
                    }

                    // we keep updating this viewmodel here
                    self.order_update_url(response.order_update_url);
                    self.order_review_html(response.order_review_html);

                    // we can post again now
                    self.submission_lockout(false);
                });
            // we record what we said
            self.previous_submission = current_submission;
        }
    });


// PAYMENT SETUP
    self.block_ui_with_message = function (message_header, message_body, showloading) {
        var loading = '<span class="loading"></span>';
        var html_message = sprintf('<div style="padding:17px;"><h1>%s</h1><p>%s</p>%s</div>',
            message_header,
            message_body ? nl2br(message_body) : '',
            (!_.isUndefined(showloading) && !showloading) ? '' : loading);

        var mobile_px_breakpoint = 1000;
        var width = $(window).width() > mobile_px_breakpoint ? '44' : 67;
        var left = (100 - width) / 2;

        $.blockUI({
            message: html_message,
            css: {
                width: sprintf('%s%%', width),
                left: sprintf('%s%%', left),
                margin: 'auto'
            }
        });
    };
    self.unblock_ui = function () {
        $.unblockUI();
    };
    self.order_review_html = ko.observable();
    self.payment_error_message = ko.observable();
    self.payments_are_ready = ko.observable(false);
    self.should_show_ppin4_stuff_callback = ko.observable(false);
    self.payment_is_out_for_processing = ko.observable(false);
    self.payment_is_out_for_processing.subscribe(function (is_out) {
        if (is_out) self.block_ui_with_message('Processing your payment details');
        else self.unblock_ui();
    });

    // form field -- we must submit this to our server
    self.payment_method_nonce = ko.observable();
    self.payment_method_nonce.subscribe(function (nonce) {
        ko.tasks.runEarly();

        if (nonce) {
            self.block_ui_with_message('Finalizing your order! Buckle up!');
        }
    });

    var recoverable_payment_error_callback = function (recoverable_message) {
        self.payment_error_message(recoverable_message);
        console.log(arguments);
    };
    var unrecoverable_alert_callback = function (unrecoverable_message) {
        self.block_ui_with_message('Fatal error',
            sprintf('Our sincerest apologies: there has been a fatal javascript error. ' +
                'Please reload this page to try again. The error follows. \n\n%s' +
                '\n\n\nIf you are having trouble completing your order please contact us by emailing at %s.' +
                '\n\n', unrecoverable_message, customer_support_email));

        console.error(Array.prototype.slice.call(arguments, 1));
    };
    self.cc_submit_event_name = 'ifc_cc::submit';
    self.cc_submit = function () {
        $(document).trigger(self.cc_submit_event_name);
    };

    var ifc_braintree = require('./ifc-braintree');
    var payment_initialization_begun = false;
    ko.pureComputed(function () {
        return !!self.purchaser.first_name();
    }).subscribe(function (should_initialize) {
        if (should_initialize && !payment_initialization_begun) {

            payment_initialization_begun = true;
            ifc_braintree.braintree_init(fetch_client_token_url,
                paypal_env,
                hosted_fields_styles_object,
                hosted_fields_number_selector,
                hosted_fields_cvv_selector,
                hosted_fields_exp_selector,
                hosted_fields_post_code_selector,
                paypal_button_selector,
                paypal_button_styles_object,
                self.total_price,
                recoverable_payment_error_callback,
                unrecoverable_alert_callback,
                self.payments_are_ready,
                self.payment_is_out_for_processing,
                self.payment_method_nonce,
                self.cc_submit_event_name,
                pppin4_selector,
                self.should_show_ppin4_stuff_callback
            );
        }
    });


}

function CustomerViewModel(require_essentials, require_shipping) {
    var self = this;

    // initialize with the value they get from the server
    self.first_name = ko.observable('').extend({required: require_essentials});
    self.last_name = ko.observable('').extend({required: require_essentials});
    self.phone = ko.observable('').extend({required: require_essentials, phone_number: require_essentials});
    self.email = ko.observable('').extend({required: require_essentials, email: true});
    self.confirm_email = ko.observable('').extend({same_as: self.email});
    self.street1 = ko.observable('').extend({required: require_shipping});
    self.street2 = ko.observable('').extend({required: false});
    self.city = ko.observable('').extend({required: require_shipping});
    self.state_province = ko.observable('').extend({required: require_shipping});
    self.postal_code = ko.observable('').extend({required: require_shipping});
    self.country = ko.observable().extend({required: require_shipping});

    self.is_intl = ko.pureComputed(function () {
        // if not blank and not US true else false
        return self.country() && self.country() !== 'US';
    });
}


module.exports = {
    OrderViewModel: OrderViewModel,
    CustomerViewModel: CustomerViewModel
};